<template>
  <div class="chat-detail" >
    <div class="chat-header">
      <div class="row">
        <div class="col-1"></div>
        <div class="col-8">
          <div class="flex">
            <img :src="user_image" />
            <div>
                <span class="name">{{ $t('savedMessage') }}</span>
              <span class="last-seen">{{ $t('online') }}</span>
            </div>
          </div>
        </div>
        <div class="col-2">
            <span class="back-btn" @click="backToChats()">
               <v-icon>
                mdi-arrow-left
              </v-icon>
            </span>
        </div>
        <div class="col-1"></div>
      </div>
    </div>
    <div class="chat-text" id="chat_detail" v-chat-scroll="{always: false}">
      <infinite-loading @infinite="infiniteHandler"  direction="top">
        <div slot="no-more"> </div>
      </infinite-loading>
      <div v-for="chat in chatLoad">
        <div class="your-message" v-if="chat.UserSenderName != UserName">
          <div class="inner">
            <span class="text">
             {{ chat.MessageText }}
           </span>
            <div>
              دیروز 12:55
            </div>
          </div>

        </div>
        <div class="my-message" v-if="chat.UserSenderName == UserName">
          <div class="inner">
           <span class="text">
            {{ chat.MessageText }}
           </span>
            <div>
             <span class="deliver">
               <v-icon>
                 mdi-check-all
               </v-icon>
             </span>
              دیروز 12:55
            </div>
          </div>

        </div>
      </div>

      <div class="chat-input-box">
        <div class="send-btn">
          <img src="../../../public/img/vec_send.png" class="first-send"/>
          <v-icon class="second-send">
            mdi-send
          </v-icon>
        </div>
        <!--         <v-icon class="first-send">-->
        <!--           mdi-send-->
        <!--         </v-icon>-->
        <div class="plus-btn">
          <v-icon>
            mdi-plus
          </v-icon>
        </div>

        <input placeholder="متن"/>
        <div class="keyboard-btn">
          <v-icon>
            mdi-keyboard-outline
          </v-icon>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading';
  export default {
    data(){
      return {
        items:'',
        // show_loading: false,
        UserId: '',
        chat: [],
        password: '',
        up: 0,
        lastMessageId : 0,
        UserName: '',
        chats: [],
        user_info: '',
        first: true,
        chatLoad: [],
        user_image: ''
      }
    },
    components: {
      InfiniteLoading,
    },
    methods: {
      infiniteHandler($state) {
        var self =this;
        // console.log("first is "+ this.first);
        if(this.first){
          setTimeout(() => {

            $state.loaded();
          }, 1000);
          return false;
        }


        // console.log("hiii"+ self.chatLoad[0].InboxItemId)
        setTimeout(() => {

          self.lastMessageId = self.chatLoad[0].InboxItemId;
          self.loadChats($state);

        }, 1000);


      },
      backToChats () {
        // this.$router.push({ path: '/dashboard', params: {} })
        this.$router.go(-1)
      },
      loadChats($state){
        var user_data = JSON.parse(localStorage.getItem("zoodpayam_profile"));
        this.user_image = user_data.ThumbPath
        const send_data = {
          "ReceiverId":this.UserId ,
          "UserId": this.UserId,
          "RecType": this.items.RecType,
          "LastMessageId": this.lastMessageId,
          "Password": this.password,
        };
        var self = this;
        this.axios.post('/LoadContactChats' , send_data,{})
          .then(response => {
            if(response.data.error == 0) {
              console.log("response edit", response.data.messages);
              self.chats = response.data.messages;

              self.chats.reverse();
              // if(self.chatLoad == []) {
              //   self.chatLoad = self.chats;
              // }else {
              //   self.chatLoad = self.chatLoad.splice(0,0,"hi");
              // }
              // console.log("$state : "+ $state)
              if(self.first){
                self.first = false;
                // self.infiniteHandler()
                self.chatLoad = self.chats;
              }
              else {
                // console.log("self.chatLoad:" + JSON.stringify(self.chatLoad[0]))
                self.chats.reverse();
                for(var i=0; i< self.chats.length;i++){
                  self.chatLoad.splice(0,0,self.chats[i]);

                }

              }
              if($state !=null){
                if(self.chats.length>0){
                  $state.loaded();
                }else {
                  $state.complete();
                }

              }
            }

          }).catch(e => {

        })
      },
      getUserInfo(){
        const send_data = {
          "UserId":this.items.UserOrGroupId
        };
        var self = this;
        this.axios.post('/GetUserInfo' , send_data,{})
          .then(response => {
            if(response.data.error == 0) {
              // console.log("user info" , response.data.userInfo)
              self.user_info = response.data.userInfo;
            }

          }).catch(e => {

        })
      },
      getGroupInfo(){

      },
      scrollToEnd() {

        var container = this.$el.querySelector("#chat_detail");
        var pageHeight =container.scrollHeight;
        container.scrollTop = pageHeight;
        // console.log("end" + container.scrollHeight)
      },
      someMethod() {
        this.$socket.invoke('socketName', payloadData)
          .then(response => {
            // console.log("hiii")
          })
      },

      async someAsyncMethod() {
        const response = await this.$socket.invoke('socketName', payloadData)

      }
    },
    mounted() {
      var user_data = JSON.parse(localStorage.getItem("zoodpayam_profile"))
      this.password = localStorage.getItem("zoodpayam_password")
      this.UserId = user_data.UserId
      this.UserName = user_data.UserName
      this.items = JSON.parse(localStorage.getItem("lastChat"));
      // console.log("items", this.items);
      this.loadChats();
      if(this.items.RecType == 0){
        this.getUserInfo();
      }
      else {
        this.getGroupInfo()
      }
      this.scrollToEnd();
    },
    // sockets: {
    //
    //   // Equivalent of
    //   // signalrHubConnection.on('someEvent', (data) => this.someActionWithData(data))
    //   someEvent(data) {
    //     this.someActionWithData(data)
    //   },
    //
    //   otherSomeEvent(data) {
    //     this.otheSomeActionWithOtherSomeData(data)
    //   }
    //
    // }
  }
</script>
